import template from './contentComment.tmpl.html'
import ContentComment from './contentComment.controller'

export default {
  template,
  restrict: 'E',
  bindings: {
    // number
    index: '=',
    // array
    comments: '=',
    // time stamp id to match with content elements
    _id: '=cId',
  },
  controllerAs: 'vm',
  controller: ContentComment,
}
